// Approvals: what's waiting for me (never something I raised), and what I raised with where it's got to.
import { useState } from "react";
import { Page, Card, Btn, Tabs, Loading, Pill } from "@/components/kit";
import api from "@/lib/api";
import { act, input, k0, State, useLoad } from "@/components/erp";
import { fmtDate } from "@/lib/money";
import { toast } from "sonner";

export default function Approvals() {
  const [tab, setTab] = useState("inbox");
  const inbox = useLoad("/approvals/inbox");
  const mine = useLoad(tab === "mine" ? "/approvals/mine" : null);
  const [picked, setPicked] = useState([]);
  const [busy, setBusy] = useState(false);
  const approveMany = async () => {
    setBusy(true);
    let n = 0;
    for (const id of picked) if (await act(() => api.post(`/approvals/${id}/act`, { action: "approve", comment: "" }))) n += 1;
    setBusy(false);
    setPicked([]);
    if (n) toast.success(`${n} approved`);
    inbox.reload();
  };
  return (
    <Page title="Approvals">
      <Tabs value={tab} onChange={setTab} tabs={[{ value: "inbox", label: `Waiting for me${inbox.data?.length ? ` (${inbox.data.length})` : ""}` }, { value: "mine", label: "Raised by me" }]} />
      {tab === "inbox" ? (
        !inbox.data ? <Loading /> : inbox.data.length === 0 ? <p className="mt-6 text-sm text-slate-500">Nothing is waiting for you.</p> : (
          <>
            <div className="mt-4 flex flex-wrap items-center gap-3">
              <label className="flex items-center gap-2 text-sm"><input type="checkbox" checked={picked.length === inbox.data.length}
                onChange={(e) => setPicked(e.target.checked ? inbox.data.map((a) => a.id) : [])} /> Select all</label>
              <Btn kind="primary" disabled={!picked.length || busy} onClick={approveMany}>Approve selected ({picked.length})</Btn>
            </div>
            <div className="mt-3 space-y-3">{inbox.data.map((a) => (
              <div key={a.id} className="flex items-start gap-3">
                <input type="checkbox" aria-label="Select" className="mt-6 h-5 w-5" checked={picked.includes(a.id)}
                  onChange={(e) => setPicked(e.target.checked ? [...picked, a.id] : picked.filter((x) => x !== a.id))} />
                <div className="min-w-0 flex-1"><Item a={a} done={inbox.reload} /></div>
              </div>))}
            </div>
          </>
        )
      ) : !mine.data ? <Loading /> : (
        <div className="mt-4 space-y-3">{mine.data.map((a) => <Item key={a.id} a={a} readOnly />)}</div>
      )}
    </Page>
  );
}

function Item({ a, done, readOnly }) {
  const [comment, setComment] = useState("");
  const [busy, setBusy] = useState(false);
  const go = async (action) => {
    setBusy(true);
    const ok = await act(() => api.post(`/approvals/${a.id}/act`, { action, comment }), action === "approve" ? "Approved" : "Rejected");
    setBusy(false);
    if (ok) done?.();
  };
  return (
    <Card className="bg-white">
      <div className="flex flex-wrap items-start justify-between gap-2">
        <div>
          <div className="text-xs text-slate-500">{a.doc_label} · raised by {a.initiator_name} · {fmtDate(a.created_at?.slice(0, 10))}</div>
          <div className="mt-1 font-semibold">{a.title}</div>
        </div>
        <div className="text-right">
          {a.amount > 0 && <div className="text-lg font-semibold tabular-nums">KES {k0(a.amount)}</div>}
          {a.allowance != null && <div className="text-xs text-slate-500">allowed without approval: {k0(a.allowance)}</div>}
          <div className="mt-1"><State s={a.status} /></div>
        </div>
      </div>
      <ol className="mt-3 flex flex-wrap gap-2 text-xs">
        {a.steps.map((s, i) => (
          <li key={i}><Pill kind={s.status === "approved" ? "green" : s.status === "rejected" ? "red" : "grey"}>
            Level {i + 1}: {s.status === "pending" ? "waiting" : `${s.status} by ${s.by_name}`}</Pill>
            {s.comment && <span className="ml-1 text-slate-500">"{s.comment}"</span>}</li>
        ))}
      </ol>
      {!readOnly && (
        <div className="mt-3 flex flex-wrap items-center gap-2">
          <input className={`${input} max-w-md`} placeholder="Comment (needed to reject)" value={comment} onChange={(e) => setComment(e.target.value)} />
          <Btn kind="primary" disabled={busy} onClick={() => go("approve")}>Approve</Btn>
          <Btn disabled={busy || !comment.trim()} onClick={() => go("reject")}>Reject</Btn>
        </div>
      )}
    </Card>
  );
}
